import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MonthlyReportService {

  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }




  generateReport(body: any) {
    const url = `${this.baseUrl}/scperformance/generate_benchmark`;
    return this.http.post(url, body).pipe(catchError(this.errorHandler));
  }
  getReportDetails() {
    const url = `${this.baseUrl}/scperformance/benchmark_retrieve_report`;
    return this.http.get<any>(url).pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(() => error || 'Server Error');
  }
}
